var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicesTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2891 2C14.5246 2 12.8769 2.88183 11.8982 4.34995L11.7911 4.51057C11.6859 4.66841 11.5907 4.83187 11.5058 5H5C3.34315 5 2 6.34315 2 8V19C2 20.6569 3.34315 22 5 22H11.9874C11.9958 22.0001 12.0041 22.0001 12.0124 22H19C20.6569 22 22 20.6569 22 19V8C22 6.34315 20.6569 5 19 5V4.71089C19 3.21371 17.7863 2 16.2891 2ZM13.5623 5.45935C14.1701 4.54763 15.1934 4 16.2891 4C16.6817 4 17 4.31828 17 4.71089V16.2891C17 16.6817 16.6817 17 16.2891 17C15.0783 17 13.9224 17.4153 13 18.1503V7.1234C13 6.58831 13.1584 6.06519 13.4552 5.61997L13.5623 5.45935ZM19 7V16.2891C19 17.7863 17.7863 19 16.2891 19C15.3922 19 14.5439 19.3669 13.9322 20H19C19.5523 20 20 19.5523 20 19V8C20 7.44772 19.5523 7 19 7ZM11 20V7.1234C11 7.08223 11.0005 7.04109 11.0016 7H5C4.44772 7 4 7.44772 4 8V19C4 19.5523 4.44772 20 5 20H11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesTab);
export default __webpack_public_path__ + "static/media/invoices-tab.757e0ccb.svg";
export { ForwardRef as ReactComponent };